// Shared styles first: CSS Modules imported by components must come after
// them to override the base classes they compose with.
import './styles/tokens.css';
import './styles/global.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error("L'element racine est introuvable.");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
